module.exports = __webpack_public_path__ + "img/obra_leave.9646f81c.jpg";